import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines, Reveal } from "@/components/Motion";

export const PageHero = ({ eyebrow, titleLines, description, image, imageAlt, children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 90]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-brand-navy text-white" data-testid={`${eyebrow.toLowerCase().replaceAll(" ", "-")}-hero`}>
      <div className="absolute inset-0 opacity-25">
        <motion.img src={image} alt="" style={{ y }} className="h-[115%] w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/82 to-brand-navy/35" />
      </div>
      <div className="section-shell relative grid min-h-[72vh] items-center gap-12 py-24 lg:grid-cols-[1.1fr_0.9fr] lg:py-32">
        <div>
          <Reveal>
            <p className="overline mb-6 text-brand-copper">{eyebrow}</p>
          </Reveal>
          <h1 className="max-w-4xl font-serif text-4xl font-black leading-[0.98] tracking-tight sm:text-5xl lg:text-7xl">
            <MaskedLines lines={titleLines} />
          </h1>
          <Reveal delay={0.45}>
            <p className="mt-8 max-w-2xl text-base leading-8 text-white/76 sm:text-lg">{description}</p>
          </Reveal>
          {children}
        </div>
        <Reveal delay={0.35} className="hidden lg:block">
          <div className="image-spotlight ml-auto max-w-md">
            <img src={image} alt={imageAlt} className="hero-frame aspect-[4/5] w-full object-cover shadow-editorial" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
